import { CellSelection } from '@tiptap/pm/tables';
export function isCellSelection(value) {
    return value instanceof CellSelection;
}
